export const RENDER_TYPE = "free-text-v1" as const;
